import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, CircleNotch } from "@phosphor-icons/react";
import { api, errMsg } from "@/lib/api";
import { AuthShell, Field } from "@/components/observer/AuthShell";
import { btnPrimary } from "@/lib/ui";
import { useAuth } from "@/lib/user";

// The install's admin door: one password (OBSERVER_PASSWORD on the server), no account. From here the admin adds
// people, who then sign in as themselves at /login.
export default function AdminLogin() {
  const nav = useNavigate();
  const { signIn } = useAuth();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/admin", { password });
      signIn(data.user);
      nav("/admin/overview", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      testid="admin-login-page"
      eyebrow="Admin"
      title={<>The admin<br />password.</>}
      intro="Opens the Admin area: people, meetings, settings, API keys. To run a meeting yourself, add yourself as a person and sign in at the usual door."
      footer={<>The admin password is OBSERVER_PASSWORD on the server. Changing it signs the admin out everywhere. <Link to="/login" className="underline hover:text-[var(--o-fg)]" data-testid="admin-login-user-link">Sign in as a person</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
        <Field label="Admin password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" autoFocus data-testid="admin-password-input" />
        {error && <p className="text-sm text-[#EF4444] font-mono" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy || !password} className={`${btnPrimary} w-full py-3.5`} data-testid="admin-login-submit">
          {busy ? <CircleNotch size={16} className="animate-spin" /> : null} Open Admin <ArrowRight size={16} weight="bold" />
        </button>
      </form>
    </AuthShell>
  );
}
